export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5259.011a46c4.jpg";